import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Input, Slider, Typography } from '@material-ui/core'

import { toolBarSliderStyle } from './ToolBarSlider.style'

export interface ToolBarSliderProps {
  onChangeHandler: (value: number, commit: boolean) => void
  label: string
  name: string
  value: number
  unit: string
  min: number
  max: number
  step: number
}

const defaultProps: ToolBarSliderProps = {
  onChangeHandler: (value: number, commit: boolean): void => {},
  label: '',
  name: '',
  value: 0,
  unit: '',
  min: -200,
  max: 200,
  step: 10
}

export const ToolBarSlider: FC<ToolBarSliderProps> = (props: ToolBarSliderProps) => {
  const classes = toolBarSliderStyle()

  const handleSliderChange = (value: number | number[], commit: boolean): void => {
    props.onChangeHandler(value as number, commit)
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, min: number, max: number): void => {
    const value = Number(event.target.value)
    if (value < min || value > max) {
      return
    }
    props.onChangeHandler(value, true)
  }

  return (
    <div>
      <Typography id={`discrete-slider-${props.name}`} className={classes.discreteSlider} gutterBottom>
        <FormattedMessage id={props.label} />
      </Typography>

      <div className={classes.sliderContainer}>
        <Slider
          name={props.name}
          aria-labelledby={`discrete-slider-${props.name}`}
          valueLabelDisplay='off'
          min={props.min}
          max={props.max}
          value={props.value}
          onChange={(event: any, newValue: number | number[]): void => { handleSliderChange(newValue, false) }}
          onChangeCommitted={(event: any, newValue: number | number[]): void => { handleSliderChange(newValue, true) }}
          className={classes.slider}
        />
        <Input
          name={props.name}
          className={classes.input}
          value={props.value}
          margin='dense'
          disableUnderline
          onChange={(event: React.ChangeEvent<HTMLInputElement>): void => { handleInputChange(event, -200, 200) }}
          inputProps={{
            style: { textAlign: 'center', padding: 0 },
            step: props.step,
            min: props.min,
            max: props.max,
            type: 'number',
            'aria-labelledby': 'input-slider'
          }}
        /> <span className={classes.unit}>{props.unit}</span>
      </div>
    </div>
  )
}

ToolBarSlider.defaultProps = defaultProps

export default ToolBarSlider
